<template>
    <div>
        <edit-member-email-modal
            v-model="show_email_dialog"
            :memberId="member.id"
            :modelProp="emailSelected"
            :valuelists="valuelists"
            @successful-email-save="refreshEmailData"
        />
        <v-form name="manageEmailsForm" ref="manageEmailsForm">
            <div class="tw-p-1" >
                <v-btn :loading="archiveLoading" class="main-btn" @click="addEmail()">Add Email</v-btn>
            </div>
            <smart-table
                id="memberemails_list"
                :endpoint="route('memberemails.ajax_list', member.id)"
                :headers="headers"
                :items-per-page="20"
                flat
                class="row-pointer"
                ref="memberemails_list"
                @click:row="editEmail"
            >
                <template v-slot:item.updated_at="{ isMobile, item, header, value, index}">
                    {{ new Date(item.updated_at).toLocaleString() }}
                </template>
                <template v-slot:item.updated_by="{ isMobile, item, header, value, index}">
                    {{ item.updated_by?.first_name }} {{ item.updated_by?.last_name }}
                </template>
                <template v-slot:item.default="{ isMobile, item, header, value, index}">
                    <template v-if="item.default === 1">
                        <v-chip color="grey" dark>Default</v-chip>
                    </template>
                </template>
            </smart-table>
        </v-form>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import EditMemberEmailModal from "@/Pages/InternalPages/Members/Modals/EditMemberEmailModal";

    export default {
        name: "MembersManageEmails",
        components: {
            SmartTable,
            InternalHeader,
            EditMemberEmailModal,
        },
        props: {
            'input': {
                type: Object,
                required: true,
                default: function () {
                    return {}
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'isEditProp': {
                type: Boolean,
                required:false,
                default: function() {
                    return false
                }
            },
        },
        data() {
            return {
                show_email_dialog: false,
                emailSelected: this.email,
                member: this.input,
                constant: this.constants,
                valuelist: this.valuelists,
                saveLoading: false,
                archiveLoading: false,
                isEdit: this.isEditProp,
                rules: {
                    required: value => !!value || 'Required',
                },
                errors: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'email',        text: 'Email',              align: `start`, sortable: true, optional: false, },
                    {value: 'note',         text: 'Notes',              align: `start`, sortable: true, optional: false, },
                    {value: 'updated_at',   text: 'Modified Date',      align: `start`, sortable: true, optional: false, },
                    {value: 'updated_by',   text: 'Modified By',        align: `start`, sortable: true, optional: false, },
                    {value: 'default',      text: 'Default',            align: `start`, sortable: true, optional: false, },
                ]
            },
            getRegions() {
                return Object.values(this.constant.MEMBER_REGIONS)
            },
            getLanguages() {
                return Object.values(this.constant.MEMBER_LANGUAGES)
            },
            isUserAdmin() {
                if (this.$page.user.role === 'ADMIN') {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            editEmail(item) {
                this.emailSelected = item
                this.show_email_dialog = true
            },
            addEmail() {
                this.emailSelected = null
                this.show_email_dialog = true
            },
            findValuelist(list, id) {
                if (list && id) {
                    return list.find(obj => obj.value === id)
                } else {
                    return ""
                }
            },
            refreshEmailData() {
                this.$refs.memberemails_list.refreshList()
            },
        },
        watch: {
            input(newInput, oldInput) {
                this.member = newInput
            },
        }
    }
</script>
<style scoped>

.section > .v-input{
    flex-grow: 0;
}

</style>
